function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbd00",
  d: "M7.957 110.545a8.963 8.963 0 0 1 1.269-4.607v-5.723H3.5a16.984 16.984 0 0 0 0 20.66h5.726v-5.723a8.963 8.963 0 0 1-1.269-4.607z",
  transform: "translate(0 -93.57)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0f9d58",
  d: "M199.979 374.223L196 378.2l3.979 3.979a16.847 16.847 0 0 0 10.33-3.5v-5.717h-5.717a9.017 9.017 0 0 1-4.613 1.261z",
  transform: "translate(-183.003 -348.23)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#31aa52",
  d: "M58.546 325.477l-5.723 5.723a17.249 17.249 0 0 0 1.469 1.673 16.864 16.864 0 0 0 12 4.972v-7.957a9.022 9.022 0 0 1-7.746-4.411z",
  transform: "translate(-49.32 -303.894)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#3c79e6",
  d: "M272.975 201.215a17.127 17.127 0 0 0-.278-3.075l-.149-.816H256v7.957h8.054a8.977 8.977 0 0 1-3.44 3.689l5.717 5.717a17.247 17.247 0 0 0 1.669-1.469 16.865 16.865 0 0 0 4.975-12.003z",
  transform: "translate(-239.025 -184.239)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#cf2d48",
  d: "M206.355 10.6l.7.7 5.627-5.627-.7-.7a16.864 16.864 0 0 0-12-4.972L196 3.979l3.979 3.979a8.959 8.959 0 0 1 6.376 2.642z",
  transform: "translate(-183.003)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#eb4132",
  d: "M66.295 7.957V0a16.865 16.865 0 0 0-12 4.972 17.232 17.232 0 0 0-1.469 1.673l5.723 5.723a9.022 9.022 0 0 1 7.75-4.411z",
  transform: "translate(-49.319)"
});

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.951,
    height: 33.951,
    viewBox: "0 0 33.951 33.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.1d00f583.svg";
export { ForwardRef as ReactComponent };